export default __webpack_public_path__ + "static/media/Catacomb Gloves.0e43d361.jpg";